(() => {
  'use strict';

  const ICONS = {
    menu: 'tabler:menu-2',
    search: 'tabler:search',
    user: 'tabler:user-circle',
    cart: 'tabler:shopping-cart',
    close: 'tabler:x',
    left: 'tabler:arrow-left',
    right: 'tabler:arrow-right',
    chevronRight: 'tabler:chevron-right',
    chevronDown: 'tabler:chevron-down',
    store: 'tabler:building-store',
    briefcase: 'tabler:briefcase-2',
    truck: 'tabler:truck-delivery',
    leaf: 'tabler:leaf',
    package: 'tabler:package',
    support: 'tabler:headset',
    messages: 'tabler:messages',
    shield: 'tabler:shield-check',
    lock: 'tabler:lock',
    building: 'tabler:building',
    person: 'tabler:user',
    pin: 'tabler:map-pin',
    file: 'tabler:file-description',
    check: 'tabler:circle-check',
    bowl: 'tabler:bowl',
    noodles: 'tabler:bowl-chopsticks',
    bottle: 'tabler:bottle',
    pantry: 'tabler:chef-hat',
    snack: 'tabler:cookie',
    kitchen: 'tabler:tools-kitchen-2',
    category: 'tabler:category-2'
  };

  const all = (root, selector) => {
    const out = [];
    if (root && root.nodeType === 1 && root.matches(selector)) out.push(root);
    if (root && root.querySelectorAll) out.push(...root.querySelectorAll(selector));
    return out;
  };

  const makeIcon = (icon, className = '') => {
    const el = document.createElement('iconify-icon');
    el.setAttribute('icon', icon);
    el.setAttribute('aria-hidden', 'true');
    el.className = ['wk-iconify', className].filter(Boolean).join(' ');
    return el;
  };

  const replaceSvg = (svg, icon) => {
    if (!svg || svg.dataset.wkIconifyDone) return;
    const oldClass = svg.getAttribute('class') || '';
    const el = makeIcon(icon, oldClass);
    svg.replaceWith(el);
  };

  const setContainerIcon = (container, icon) => {
    if (!container) return;
    const existing = container.querySelector(':scope > iconify-icon.wk-iconify');
    if (existing && existing.getAttribute('icon') === icon) {
      container.dataset.wkIconify = icon;
      return;
    }
    if (container.dataset.wkIconify === icon) return;
    container.replaceChildren(makeIcon(icon));
    container.dataset.wkIconify = icon;
  };

  const textOf = (el) => (el?.textContent || '').trim().toLowerCase();

  const categoryIcon = (text) => {
    const value = (text || '').toLowerCase();
    if (value.includes('rijst') || value.includes('rice')) return ICONS.bowl;
    if (value.includes('noedel') || value.includes('noodle')) return ICONS.noodles;
    if (value.includes('saus') || value.includes('sauce') || value.includes('soja') || value.includes('oester') || value.includes('vis')) return ICONS.bottle;
    if (value.includes('kokos') || value.includes('conserv') || value.includes('blik')) return ICONS.package;
    if (value.includes('koken') || value.includes('voorraad')) return ICONS.pantry;
    if (value.includes('snack')) return ICONS.snack;
    if (value.includes('drank') || value.includes('drink') || value.includes('beverage') || value.includes('koffie') || value.includes('thee')) return ICONS.bottle;
    if (value.includes('keuken') || value.includes('huishoud')) return ICONS.kitchen;
    return ICONS.category;
  };

  function upgradeBaseIcons(root) {
    const direct = [
      ['.wk-simple-header__burger svg.icon', ICONS.menu],
      ['.wk-simple-header__search svg.icon', ICONS.search],
      ['.w83-search svg.icon', ICONS.search],
      ['.search-drawer__form svg.icon', ICONS.search],
      ['.wk-simple-header__account svg.icon', ICONS.user],
      ['.wk-simple-header__cart svg.icon', ICONS.cart],
      ['.search-drawer__close svg.icon', ICONS.close],
      ['[data-hero-prev] svg.icon', ICONS.left],
      ['[data-hero-next] svg.icon', ICONS.right],
      ['.w105-search svg.icon', ICONS.search],
      ['.w105-action--login svg.icon', ICONS.user],
      ['.w105-cart svg.icon', ICONS.cart]
    ];
    direct.forEach(([selector, icon]) => all(root, selector).forEach((svg) => replaceSvg(svg, icon)));
  }

  function upgradeTrustBar(root) {
    all(root, '.w85-trustbar__item').forEach((item) => {
      const title = textOf(item.querySelector('.w85-trustbar__title'));
      let icon = ICONS.briefcase;
      if (title.includes('authentieke')) icon = ICONS.leaf;
      else if (title.includes('levering')) icon = ICONS.truck;
      else if (title.includes('flexibele')) icon = ICONS.package;
      else if (title.includes('persoonlijke')) icon = ICONS.support;
      setContainerIcon(item.querySelector('.w85-trustbar__icon'), icon);
    });
  }

  function upgradeHero(root) {
    all(root, '.w70-proofcard').forEach((card) => {
      const label = textOf(card.querySelector('.w70-proofcard__label'));
      let icon = ICONS.store;
      if (label.includes('zakelijk')) icon = ICONS.briefcase;
      if (label.includes('bezorg')) icon = ICONS.truck;
      setContainerIcon(card.querySelector('.w70-proofcard__icon'), icon);
    });
    all(root, '.w65-intro__secondary > span[aria-hidden="true"]').forEach((el) => setContainerIcon(el, ICONS.right));
  }

  function upgradeCart(root) {
    all(root, '.wk73-method__icon').forEach((el) => setContainerIcon(el, ICONS.truck));
    all(root, '.wk73-empty__icon').forEach((el) => setContainerIcon(el, ICONS.check));
  }

  function upgradeBusiness(root) {
    all(root, '.wk-biz77__explain-icon').forEach((el) => setContainerIcon(el, ICONS.shield));
    all(root, '.wk-biz77__gate-icon').forEach((el) => setContainerIcon(el, ICONS.lock));
    all(root, '.wk-biz77__section-title').forEach((row) => {
      const label = textOf(row);
      let icon = ICONS.file;
      if (label.includes('bedrijfs')) icon = ICONS.building;
      else if (label.includes('contact')) icon = ICONS.person;
      else if (label.includes('aflever')) icon = ICONS.pin;
      setContainerIcon(row.querySelector('.wk-biz77__section-icon'), icon);
    });
    all(root, '.wk-biz77__trust').forEach((row) => {
      const svg = row.querySelector('svg');
      if (svg) replaceSvg(svg, ICONS.lock);
    });
  }

  function upgradeMobileMenu(root) {
    all(root, '.wk-mobile-menu__close').forEach((btn) => {
      const svg = btn.querySelector('svg');
      if (svg) replaceSvg(svg, ICONS.close);
    });
    all(root, '.wk-mobile-menu__finder-field > span:first-child').forEach((el) => setContainerIcon(el, ICONS.search));
    all(root, '[data-wk-category-clear]').forEach((btn) => {
      if (btn.dataset.wkIconify !== ICONS.close) setContainerIcon(btn, ICONS.close);
    });
    all(root, '.wk-mobile-menu__service-row').forEach((row) => {
      const href = row.getAttribute('href') || '';
      let icon = ICONS.messages;
      if (href.includes('leveringskalender')) icon = ICONS.truck;
      else if (href.includes('zakelijk')) icon = ICONS.store;
      else if (href.includes('account')) icon = ICONS.user;
      setContainerIcon(row.querySelector('.wk-mobile-menu__service-icon'), icon);
    });
    all(root, '.wk-mobile-menu__arrow').forEach((el) => setContainerIcon(el, ICONS.chevronRight));
    all(root, '.wk-mobile-menu__directory summary i').forEach((el) => setContainerIcon(el, ICONS.chevronDown));
    all(root, '.wk-mobile-menu__all > span:last-child').forEach((el) => setContainerIcon(el, ICONS.right));
    all(root, '.wk-category-icon-svg').forEach((el) => {
      const host = el.closest('[data-wk-category-item]');
      const label = host?.getAttribute('data-wk-category-name') || textOf(host);
      setContainerIcon(el, categoryIcon(label));
    });
  }

  function upgradeMegaMenu(root) {
    all(root, '.w88-rail__item').forEach((item) => {
      const label = textOf(item.querySelector('.w88-rail__label'));
      setContainerIcon(item.querySelector('.w88-rail__icon'), categoryIcon(label));
      setContainerIcon(item.querySelector('.w88-rail__arrow'), ICONS.chevronRight);
    });
    all(root, '.w105-rail-link').forEach((item) => {
      const label = textOf(item);
      setContainerIcon(item.querySelector('.w105-rail-link__icon'), categoryIcon(label));
      setContainerIcon(item.querySelector('.w105-rail-link__arrow'), ICONS.chevronRight);
    });
    all(root, '.w105-panel__cta-icon').forEach((el) => setContainerIcon(el, ICONS.kitchen));
    const benefitIcons = [ICONS.briefcase, 'tabler:percentage', ICONS.truck, ICONS.support];
    all(root, '.w105-mega__benefits').forEach((wrap) => {
      [...wrap.children].forEach((item, index) => {
        const holder = item.querySelector(':scope > span:first-child');
        if (holder) setContainerIcon(holder, benefitIcons[index] || ICONS.category);
      });
    });
  }

  function upgradeMisc(root) {
    all(root, '.w37-local-band__link > span[aria-hidden="true"]').forEach((el) => setContainerIcon(el, ICONS.right));
  }

  function upgrade(root = document) {
    upgradeBaseIcons(root);
    upgradeTrustBar(root);
    upgradeHero(root);
    upgradeCart(root);
    upgradeBusiness(root);
    upgradeMobileMenu(root);
    upgradeMegaMenu(root);
    upgradeMisc(root);
  }

  if (!window.customElements?.whenDefined) return;

  const eventRoot = (event) => {
    if (event?.detail?.root instanceof Element) return event.detail.root;
    if (event?.target instanceof Element) return event.target;
    return document;
  };

  customElements.whenDefined('iconify-icon').then(() => {
    upgrade(document);
    document.addEventListener('shopify:section:load', (event) => upgrade(eventRoot(event)));
    document.addEventListener('wokora:content-updated', (event) => upgrade(eventRoot(event)));
    document.addEventListener('wokora:cart-drawer-refreshed', (event) => upgrade(eventRoot(event)));
  });
})();
